module.exports = __webpack_public_path__ + "static/media/machine-card.1595f204.png";